export default function Portfolio() {
  const projects = [
    {
      title: 'Pintura Residencial Completa',
      description: 'Projeto de pintura completa em residência com aplicação de texturas decorativas',
      image: 'https://public.readdy.ai/ai/img_res/2075dedf15d732197f31d7ce538e5654.jpg',
    },
    {
      title: 'Fachada de Prédio Comercial',
      description: 'Pintura externa de edifício comercial com acabamento premium',
      image: 'https://readdy.ai/api/search-image?query=Modern%20commercial%20building%20exterior%20with%20fresh%20professional%20paint%20job%20in%20elegant%20colors%20clean%20facade%20with%20windows%20and%20architectural%20details%20bright%20daylight&width=800&height=600&seq=portfolio2&orientation=landscape',
    },
    {
      title: 'Textura Grafiato',
      description: 'Aplicação de textura grafiato em área externa com acabamento impecável',
      image: 'https://readdy.ai/api/search-image?query=Wall%20with%20grafiato%20texture%20finish%20showing%20detailed%20textured%20surface%20in%20elegant%20neutral%20color%20professional%20decorative%20plaster%20application%20in%20modern%20interior&width=800&height=600&seq=portfolio3&orientation=landscape',
    },
    {
      title: 'Pintura de Condomínio',
      description: 'Revitalização completa de áreas comuns de condomínio residencial',
      image: 'https://readdy.ai/api/search-image?query=Condominium%20common%20area%20with%20fresh%20paint%20modern%20apartment%20building%20lobby%20or%20hallway%20with%20clean%20painted%20walls%20in%20light%20colors%20professional%20finish&width=800&height=600&seq=portfolio4&orientation=landscape',
    },
    {
      title: 'Escritório Corporativo',
      description: 'Pintura e acabamento de escritório com cores corporativas personalizadas',
      image: 'https://readdy.ai/api/search-image?query=Modern%20corporate%20office%20interior%20with%20professionally%20painted%20walls%20in%20corporate%20colors%20clean%20workspace%20with%20desks%20and%20contemporary%20design%20excellent%20lighting&width=800&height=600&seq=portfolio5&orientation=landscape',
    },
    {
      title: 'Casa com Pedra Cristal',
      description: 'Aplicação de pedra cristal em fachada residencial',
      image: 'https://readdy.ai/api/search-image?query=Residential%20house%20exterior%20wall%20with%20decorative%20crystal%20stone%20texture%20finish%20elegant%20facade%20detail%20showing%20textured%20coating%20in%20neutral%20tones%20modern%20architecture&width=800&height=600&seq=portfolio6&orientation=landscape',
    },
  ];

  return (
    <section id="portfolio" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-800 mb-4">Nosso Portfólio</h2>
          <p className="text-xl text-gray-600 mb-6">
            Confira alguns dos nossos trabalhos realizados em São José dos Campos e região
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-orange-500 to-yellow-500 mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105"
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                <h3 className="text-xl font-bold mb-2">{project.title}</h3>
                <p className="text-sm opacity-90">{project.description}</p>
              </div>
              <div className="bg-gradient-to-r from-orange-500 to-yellow-500 p-4">
                <h3 className="text-lg font-bold text-white">{project.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
